import { Context } from '@vue-storefront/core';
type WishClearResponse = {
  data: any;
}

export default async function wishClear({ client, config }: Context): Promise<WishClearResponse> {
  // Create URL object containing full endpoint URL
  const url = new URL('/mall/fav/clear', config.api.url);
  // console.log('## 添加心愿单url ##', url);
  // eslint-disable-next-line camelcase
  const { data } = await client.post(url.href, { good_id: 14 });
  // console.log('## 添加心愿单回执 ##', data);
  // Return data from the API
  return data;
}
